module.exports = __webpack_public_path__ + "img/zhuanpan-2.c2101ce9.png";